// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__NY21X","list_item":"styles_list_item__24E-G","more":"styles_more__n0STE"};